export const LOCATION_FETCH = 'LOCATION_FETCH'
export const LOCATION_CREATE = 'LOCATION_CREATE'
export const LOCATION_UPDATE = 'LOCATION_UPDATE'
